export class CreateProgramRequest
{    
    public name: string;
    public description: string;
    public companyId: string;
}